import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
	selector: "sdp-confirmation-dialog",
	templateUrl: "./confirmation-dialog.component.html"
})
export class ConfirmationDialogComponent {
	public title = "";
	public message = "";
	public confirmationMessage = "";
	public confirmationPlaceholder = "";
	public confirmValue: (value: string) => boolean;
	public buttonCancel = "";
	public buttonAction = "";

	public confirmationValue = "";

	constructor(
		public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
		private readonly domSanitizer: DomSanitizer
	) {
		this.confirmValue = () => false;
	}

	public async deleteAction(deleteItem: boolean) {
		this.dialogRef.close(deleteItem);
	}
}
